import { useMutation } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { Client } from '../Client';

const MEMBER_TO_CUSTOMER = gql`
  mutation member_to_customer($jwtToken: String!) {
    member_to_customer(jwtToken: $jwtToken) {
      status
      message
      userData {
        id
        email
        first_name
        last_name
        street_address
        city
        state
        phone
        birthday
        zipcode
        exp
      }
    }
  }
`;

interface MemberCustomerVariables {
  jwtToken: string;
}

export const memberCustomer = async ({ jwtToken }: MemberCustomerVariables): Promise<any> => {
  if (!jwtToken) {
    throw new Error('Invalid Token');
  }
  const data = await Client.request(MEMBER_TO_CUSTOMER, {
    jwtToken
  });
  return data;
};

export const useMemberCustomerMutation = (
  onSuccessCallback: (data: any) => void,
  onErrorCallback: (error: any) => void
) => {
  return useMutation({
    mutationFn: memberCustomer,
    onMutate: () => {},
    onError: (error) => {
      onErrorCallback(error);
    },
    onSuccess: (data) => {
      onSuccessCallback(data?.member_to_customer);
    },
    onSettled: () => {}
  });
};
